import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../UniformComponents/Modal'
import Button from '../UniformComponents/Button'
import QuestionBuilderStore from './QuestionBuilderStore'
import QuestionForm from './form/QuestionForm'
import createFormFields from './form/FieldDefinition'
import questionFields from './form/QuestionFields'
import AlertModal from '../UniformComponents/AlertModal'
import Typography from '../UniformComponents/Typography'

import './question-builder.scss'

@observer
class QuestionBuilder extends Component {
    constructor(props) {
        super(props)
        const { store } = props
        this.questionBuilderStore = new QuestionBuilderStore(store, store.survey)
    }

    async componentDidMount() {
        await this.questionBuilderStore.init()
    }

    renderEditSubQueModal = () => {
        const {
            subQuestionMap, subQueOptionId, toggleSubQueModal, question,
        } = this.questionBuilderStore

        if (!subQueOptionId) return null

        const { store: subQueStore } = subQuestionMap.get(subQueOptionId)

        const subQueFields = createFormFields(
            subQueStore,
            question.questionTypeCode,
            questionFields,
            'editSubQue',
            subQueStore.question.questionTypeCode,
        )

        return (
            <Modal
                show={Boolean(subQueOptionId)}
                onClose={toggleSubQueModal}
                nestedModal
            >
                <div className="question-builder-popover">
                    <div className="form-header">
                        <h2>{i18n.t('questionBuilder.optionsMenu.editQue')}</h2>
                        <p className="desc">
                            {i18n.t('questionBuilder.editSubQue.info.desc')}
                        </p>
                    </div>
                    <QuestionForm
                        store={subQueStore}
                        formFields={subQueFields}
                    />
                    <div className="form-button-wrapper">
                        <Button
                            label={i18n.t('close')}
                            cssClass="regular tertiary"
                            onClick={toggleSubQueModal}
                        />
                        <Button
                            label={i18n.t('save')}
                            icon="fa-light fa-floppy-disk"
                            cssClass="regular primary"
                            onClick={() => {
                                this.questionBuilderStore.saveSubQuestion(subQueOptionId)
                            }}
                        />
                    </div>
                </div>
            </Modal>
        )
    }

    renderUsedInOtherSurveysContent = () => (
        <div>
            <h3 style={{ fontWeight: 400 }}>
                {i18n.t('qe_other_title')}
            </h3>
            <br />
            <div className="list">
                {this.questionBuilderStore.listOfOtherSurveys.map(({ name }) => (
                    <p style={{ fontSize: 16 }}>{name}</p>
                ))}
            </div>
            <br />
            <br />
            <p style={{ fontSize: 18 }}>
                {i18n.t('ge_other_desc')}
            </p>
        </div>
    )

    renderButtons = () => {
        const {
            closeModal,
            saveDisabled,
            saveQuestion,
            toggleTab,
            tabName,
        } = this.questionBuilderStore

        return (
            <>
                <Button
                    label={i18n.t('close')}
                    cssClass="regular tertiary"
                    onClick={closeModal}
                />
                {tabName === 'newQuestion'
                    ? (
                        <Button
                            label={i18n.t('next')}
                            cssClass="regular secondary"
                            disabled={saveDisabled}
                            onClick={() => toggleTab('standard')}
                        />
                    )
                    : (
                        <Button
                            label={i18n.t('save')}
                            icon="fa-light fa-floppy-disk"
                            cssClass="regular primary"
                            disabled={saveDisabled}
                            onClick={saveQuestion}
                        />
                    )}
            </>
        )
    }

    render() {
        const { store } = this.props
        const {
            tabName, formFields, builderLoading, isEdit,
            setTabs, toggleTab, closeModal,
        } = this.questionBuilderStore
        const tabs = setTabs()
        return (
            <div id="que-builder">
                <Modal
                    show={store.showQuestionEditor}
                    onClose={closeModal}
                    loading={builderLoading}
                    cssClass="que-builder-modal large"
                >
                    <div id="question-builder">
                        <div className="question-builder-head form-tabs-header">
                            <h2 className="title">
                                {isEdit ? i18n.t('q_editor_title') : i18n.t('q_editor_title_create')}
                            </h2>
                            <div className="tab-btns">
                                {tabs.filter((t) => tabName !== 'newQuestion' && !t.hidden).map((t) => (
                                    <Button
                                        key={t.name}
                                        cssClass={`tab ${tabName === t.name ? 'selected' : ''}`}
                                        label={t.label}
                                        onClick={() => {
                                            toggleTab(t.name)
                                        }}
                                    />
                                ))}
                            </div>
                        </div>
                        {store.showDebug && isEdit && this.questionBuilderStore.question
                            ? (
                                <div>
                                    <Typography cssClass="question-id-container">
                                        Edit [<div onClick={navigator.clipboard.writeText(this.questionBuilderStore.question.id)}>{this.questionBuilderStore.question.id}</div>]
                                    </Typography>

                                    <br />
                                </div>
                            ) : null}
                        <QuestionForm
                            store={this.questionBuilderStore}
                            formFields={formFields}
                        />
                        <div className="form-button-wrapper">
                            {this.renderButtons()}
                        </div>
                    </div>
                </Modal>
                <AlertModal
                    show={this.questionBuilderStore.showEditModal}
                    content={i18n.t('questionbuilder.editQuestion.title')}
                    noLabel={i18n.t('close')}
                    yesLabel={i18n.t('edit_question')}
                    onNo={this.questionBuilderStore.toggleEditModal}
                    onYes={() => {
                        this.questionBuilderStore.toggleEditModal()
                        this.questionBuilderStore.alterOverrideEdit(true)
                    }}
                />
                <AlertModal
                    show={this.questionBuilderStore.showOptionEditModal}
                    content={i18n.t('questionBuilder.option.editAlert')}
                    noLabel={i18n.t('close')}
                    yesLabel={i18n.t('questionBuilder.optionsMenu.allowEdit')}
                    onNo={this.questionBuilderStore.toggleOptionEditModal}
                    onYes={(e) => {
                        this.questionBuilderStore.toggleOptionEditModal()
                        this.questionBuilderStore.handleOptionEdit(e)
                    }}
                />
                <AlertModal
                    show={this.questionBuilderStore.showSkipLogicAlertModal}
                    content={i18n.t('questionBuilder.skipLogic.alertText')}
                    noLabel={i18n.t('close')}
                    hideCancel
                    onNo={this.questionBuilderStore.toggleSkipLogicAlertModal}
                    onCancel={this.questionBuilderStore.toggleSkipLogicAlertModal}
                />
                <AlertModal
                    show={this.questionBuilderStore.showProductTypeAlertModal}
                    content={i18n.t('questionBuilder.productTypes.alert')}
                    noLabel={i18n.t('close')}
                    yesLabel={i18n.t('next')}
                    onNo={this.questionBuilderStore.toggleShowProductTypeModal}
                    onYes={() => {
                        this.questionBuilderStore.toggleTab('productTypes')
                        this.questionBuilderStore.toggleShowProductTypeModal()
                    }}
                />
                <AlertModal
                    show={this.questionBuilderStore.showUsedInOtherSurveysModal}
                    content={this.renderUsedInOtherSurveysContent()}
                    withCancel
                    noLabel={i18n.t('ge_other_update')}
                    yesLabel={i18n.t('ge_other_clone')}
                    onNo={() => {
                        this.questionBuilderStore.persistQuestion(false)
                        this.questionBuilderStore.toggleShowUsedInOtherSurveysModal()
                    }}
                    onYes={() => {
                        this.questionBuilderStore.persistQuestion(true)
                        this.questionBuilderStore.toggleShowUsedInOtherSurveysModal()
                    }}
                    onCancel={() => {
                        this.questionBuilderStore.toggleShowUsedInOtherSurveysModal()
                    }}
                />
                {this.renderEditSubQueModal()}
            </div>
        )
    }
}

export default QuestionBuilder
